import styled from "styled-components";

const StyledStackedCards = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const StackedCards = ({ children, ...rest }) => <StyledStackedCards {...rest}>{children}</StyledStackedCards>;

const StyledStackedCard = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  opacity: ${(props) => (props.active ? 1 : 0)};
  visibility: ${(props) => (props.active ? "visible" : "hidden")};
  transition:
    opacity 0.53s,
    visibility 0.53s;
`;

export const StackedCard = ({ children, ...rest }) => <StyledStackedCard {...rest}>{children}</StyledStackedCard>;
